<template>
  <el-form
    :model="tbForm"
    ref="form"
    label-width="12%"
    v-loading="loading">
    <!-- <slot name="errMsg"></slot> -->
    <section>
      <div class="title ft-12">
        <span>类目选择</span>
      </div>
      <div class="conf">
        <el-form-item label="商品分类:" prop="categoryIds">
          <div class="category ft-12">
            <category-input
              ref="cinput"
              :categoryIds="tbForm['categoryIds']"
              :baseItemId="baseItemId"
              :isSupportAi="true"
              @change="categoryIdsChange"
              platform="tb" />
          </div>
        </el-form-item>
      </div>
    </section>

    <template v-if="formSections.length">
    <section
      v-for="(section, sectionIndex) in formSections"
      :key="sectionIndex">
      <div class="title ft-12">
        <span>{{section.title}}</span>
      </div>
      <div class='conf'>
        <template v-for="(field) in section.children">
          <el-form-item
            v-if="field.isShowFn ? field.isShowFn(tbForm) : true"
            :key="field.name"
            :prop="field.propName || field.name"
            :label="formatLabel(field)"
            :rules="field.rules"
            :class="[noLabelStyles.includes(field.name) ? 'noLabel' : '']"
            >
            <UseCategoryTemplate :detailHasCategory="tbForm['detailHasCategory']" :detailId="tbForm['id']" :baseItemId="baseItemId"  v-if="field.name =='catProp'" :categoryIds="tbForm['categoryIds']" platform="tb" :getPropValues="getPropValues" @clickFill="clickTemPlateFill">
              <component
                :ref="field.name"
                :is="field.component.component"
                :props="field.component.props"
                >
              </component>
            </UseCategoryTemplate>
            <template v-else>
              <div
                class="preText"
                v-if="field._preText"
                v-html="field._preText"></div>
              <component
                :ref="field.name"
                :is="field.component.component"
                :props="field.component.props"
                @fieldChanged="specificationsFieldChanged"
                @file-upload="handleImageUpload"
                @blur="handleBlur"
                :showAuditResult="showAuditResult"
                :auditFileList="auditFileList"
                :shopList="shopList"
              ></component>
              <div
                class="suffixText"
                v-if="field._suffixText"
                v-html="field._suffixText"></div>
              <div v-if="field.label==='一口价'" class="tips ft-12">
                <span v-if="showPriceTip" class="fix-price-remind el-form-item__error">一口价必须和任意规格的单价一致</span>
                <el-button type="link" class="get-low" @click="getPriceLow(field)">取最低价</el-button>
              </div>
              <div
                v-else-if="field.tipRule && field.tipRule.length && (field.isShowTipFn ? field.isShowTipFn(tbForm) : true) && !(field.name === 'saleProp' && removePureItem && tbForm.pureType)"
                class="tips ft-12">
                <span
                  style="display: block"
                  v-for="(tip, tipIndex) in field.tipRule"
                  v-html="tip"
                  :key="tipIndex"></span>
              </div>
            </template>
          </el-form-item>
        </template>
      </div>
    </section>
    </template>
    <slot name="shipShelf"></slot>
  </el-form>
</template>

<script>
import CategoryInput from "../../../PlatformCategoryInput/index.vue";
import UseCategoryTemplate from '../../../UseCategoryTemplate.vue'
import { formatDataForm, formatFormData } from '../../utils/data';
import { cloneDeep } from 'lodash'
import shopListMixin from '../../../shopListMixin';

import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    CategoryInput,
    UseCategoryTemplate
  },
  mixins: [shopListMixin],
  props: {
    formSections: {
      type: Array,
      default: () => [],
    },
    auditFileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    priceList:{
      type: Array,
      default: () => {
        return []
      }
    },
    showAuditResult: {
      type: Boolean,
      default: false,
    },
    baseItemId: [Number, String],
    shopList:{
      type: Array,
      default: () => []
    },
    openSource:{
      type:String,
      default:''
    },
  },
  inject: {},
  data() {
    return {
      loading: false,
      rules: {},
      noLabelNames: ['saleProp', 'globalStock', 'invoice', 'sellPromise', 'deliveryTimeSetBySku'],
      noLabelStyles: ['saleProp', 'globalStock'],
      shipsTemplate: {}, // 运费模板列表
      shipsValue: {}, // 运费模板值
      shelfState: 1,
      priceValue:'',
      showPriceTip: false
    };
  },
  watch: {
    priceList(list){
      this.checkList()
    },
  },
  computed: {
    ...mapGetters(["tbForm", 'removePureItem']),
  },
  mounted(){
    if(!this.priceList.length){
      setTimeout(() => {
        this.$emit('fixedPrice');
        this.checkList()
      }, 1000);
    }
  },
  methods: {
    ...mapActions(["updateTbForm"]),
    // 类目更新后的回调
    categoryIdsChange(v) {
      this.updateTbForm({
        categoryIds: v
      })
      this.$emit("categoryChange", v)
    },
    
    formatLabel(field) {
      // 需要对部分字段特殊处理 KMERP-68827
      if (field.name === 'warranty') return '售后服务'
      if (field.name === 'tbDeliveryTime') return ' '
      if (field.name === 'sevenDayOptional') return ''
      if (field.name === 'sevenDaySupport') return ''
      return this.noLabelNames.includes(field.name) ? '' : field.label
    },
    specificationsFieldChanged() {
      this.$emit('fieldChanged')
    },
    handleImageUpload(v) {
      this.$emit('file-upload', v);
    },
    getPriceLow(field){
      // 取 this.priceList 最小值
      let min = this.priceList.length ? Math.min(...this.priceList) : 0;
      // 设置tbForm的price的值为min
      this.tbForm.price = min;
      this.priceValue = min
      this.checkList()
    },
    handleBlur(v, key){
      if(key=='price'){
        this.priceValue = v.target.value;
        this.$emit('fixedPrice')
      }
    },
    checkList() {
      const list = this.priceList || []
      if(!list.length) return

      this.priceValue = this.priceValue || this.tbForm.price;

      if (!list.includes(this.priceValue - 0)) {
        this.showPriceTip = true;
        this.$emit('fixedPriceCheck', true);
      } else {
        this.showPriceTip = false;
        this.$emit('fixedPriceCheck', false);
      }
    },
    clickTemPlateFill(row) {
      const parsePlatformCatProp = row.platformCatProp ? JSON.parse(row.platformCatProp) : [];
      const catFormSection = cloneDeep(this.formSections).filter(section => section.title === "基础信息")
      catFormSection.forEach(item => {
        item.children = item.children.filter(childItem => childItem.name === "catProp")
      })
      const catForm = formatDataForm({ fieldDescriptorList: parsePlatformCatProp }, catFormSection);
      this.updateTbForm(catForm);
    },
    getPropValues() {
      const fieldDescriptorList = formatFormData(this.tbForm, this.formSections)
      return fieldDescriptorList.filter(item => item && item.name === "catProp");
    },
  }
};
</script>

<style lang="scss" scoped>
.title {
  padding: 10px;
  background: #f8f8f8;
  font-weight: 600;
}
.conf {
  margin-top: 20px;
}
.noLabel {
  & ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
  & ::v-deep .el-form-item__error {
    margin-left: 12% !important;
  }
}
.preText, .suffixText {
  font-size: 12px;
  display: inline-block;
}
.preText {
  margin-right: 5px;
}
.suffixText {
  margin-left: 5px;
}
.fix-price-remind{
  color:#F56C6C;
  margin-right: 20px;
}
.get-low{
  margin-left: -10px;
}
</style>